<template>
	<v-container fill-height fluid class="pa-0">
		<Local />
		<Excluir />
		<Novo />
		<v-row class="ma-0">
			<v-col cols="12" class="pa-0">
				<v-card tile :height="this.$store.getters.alturaContent" cols="12" :loading="loading">
					<v-card-title>
						<v-toolbar flat dense>
						<v-spacer></v-spacer>
							<v-btn color="primary" small @click="criarNovoLocal()">Novo</v-btn>
						</v-toolbar>
					</v-card-title>
					<v-card-text>
						<v-data-table :page.sync="pagina" hide-default-footer :height="this.$store.getters.alturaContent - 170"
						locale="pt-BR" dense fixed-header class="table-item" :items="locais" :headers="fields" :items-per-page="itensPorPagina">
							<template v-slot:item.action="{ item }">
								<v-btn icon class="mx-1" color="primary" @click="editar(item)">
									<v-icon>mdi-lead-pencil</v-icon>
								</v-btn>
								<v-btn icon color="primary"  @click="excluir(item)">
									<v-icon>mdi-delete</v-icon>
								</v-btn>
							</template>
						</v-data-table>
						<v-row>
                            <v-col cols=12>
                                <v-pagination :length="totalPaginas" total-visible="7" v-model="pagina">
                                </v-pagination>
                            </v-col>
                        </v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import { baseApiUrl, showError } from "@/config/global"
	import axios from 'axios'
	import Local from '@/components/cadastros/locais/Local'
	import Excluir from '@/components/cadastros/locais/ExcluirLocal'
	import Novo from '@/components/cadastros/locais/NovoLocal'
	import metodos from '@/mixins/metodos.js'
	import Br from '@/config/barramento.js'

	export default{
		mixins:[metodos],
		components:{Local, Excluir, Novo},
		data(){
			return {
				loading: false,
				showModal: false,
				pagina: 1,
                totalPaginas: 1,
                itensPorPagina: 8,
				locais: [],
				local: {},
				fields: [
					{value: 'id', text: 'Código', align: 'center'},
					{value: 'descricao', text: 'Nome', align: 'center'},
					{text: 'Ações', value: 'action', align: 'center', divider: true}
				],

			}
		},
		methods:{
			buscaLocais(){
				this.loading = true
				const url = `${baseApiUrl}/Cadastros/locais/read.php`

				axios.get(url)
						.then(res => { 
							if(res.data.codigo == "01"){
								this.locais = res.data.dados
							}
							this.totalPaginas = Math.ceil(this.locais.length / this.itensPorPagina)
							this.loading = false
						})
						.catch({showError})
			},

			editar(local){
				Br.setEditarLocal(local)
			},
			criarNovoLocal(){
				Br.setNovoLocal()
			},
			
			excluir(local){

				Br.setExcluirLocal(local)
				
			}

		},

		created(){
			this.buscaLocais()

			Br.onLocalExcluido(local => {
					let idx = this.locais.findIndex((v) => {
                               return v.id == local.id
                            })

                            this.locais.splice(idx, 1)
				})

			Br.onLocalCadastrado(local => {
				
				this.locais.push(local)
			})
		}
	}
</script>

<style scoped>

</style>